import { t } from 'i18next'
import React, { useContext, useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import { replaceExpecialCharacters } from '../../../helpers/helpers';
import { Input, FormGroup, Spinner } from 'reactstrap';
import { ButtonBlue } from '../../Buttons/ButtonBlue';
import { CustomModal } from '../../CustomModal/CustomModal';
import errorIcon from '../../../assets/icons/triangule-exclamation.svg';
import sectorSuccessIcon from '../../../assets/icons/sector-success-icon.svg';
import SectorsManagementContext from '../../../context/SectorsContext/SectorsManagementContext';

export const CreateAndEditSector = () => {
    const navigate = useNavigate();
    const { sectorId } = useParams();
    const isEditing = sectorId;

    const { sectorsManagementState, getSector, createSector, editSector, removeWarningModal } = useContext(SectorsManagementContext);
    const { sectorData, sectorsToConfig, isFetching, responseSectorsService } = sectorsManagementState;

    const [sectorDataState, setSectorDataState] = useState(sectorData);

    const disabled = !!!String(sectorDataState.sectorName).trim();

    const handleChange = (e) => {
        let { value, name, checked } = e.target;

        setSectorDataState({
            ...sectorDataState,
            [name]: name === 'sectorEnabled' ? checked : replaceExpecialCharacters(value)
        })
    }

    const handleSubmit = async () => {
        if (disabled) return
        if (sectorId) {
            return await editSector(sectorDataState);
        }
        await createSector(sectorDataState);
    }

    const closeWarningModal = async () => responseSectorsService.type === 'ERROR' ? removeWarningModal() : navigate('/settings/entityManagment/sectorMaganagement');

    const goCancel = () => navigate(-1);

    const getSectorAndLoadData = async () => {
        const response = await getSector(sectorId);
        setSectorDataState(response);
    }



    useEffect(() => {
        if (isEditing && sectorsToConfig.length === 0) {
            getSectorAndLoadData();
        }
        // eslint-disable-next-line
    }, []);

    return (

        <div className='row justify-content-center'>
            <div className='col-xl-4 col-lg-7 col-sm-9 mt-5'>
                <div className='me-3 ms-3 mt-2'>

                    <CustomModal showModal={responseSectorsService.show} centered={true} setShowModal={closeWarningModal}>
                        <div className='d-flex flex-column align-items-center justify-content-center'>
                            <img src={responseSectorsService.type === 'ERROR' ? errorIcon : sectorSuccessIcon} alt="" />
                            <p className='mt-3 text-center param-section-title'>{responseSectorsService.text}</p>
                            <p type="button" className='custom-modal-btn-ok' onClick={closeWarningModal}>{t('UNDERSTOOD')}</p>
                        </div>
                    </CustomModal>

                    {isFetching ?
                        <div className="d-flex mt-4 justify-content-center">
                            <Spinner />
                        </div>
                        : null}

                    <div>
                        <p className='m-0 titlelabel-filter'>{t('NAME')}</p>
                        <p>
                            <input
                                className='form-control'
                                type="text"
                                name='sectorName'
                                value={sectorDataState.sectorName}
                                onChange={handleChange}
                            />
                        </p>
                    </div>

                    <div className='mt-3'>
                        <div style={{ backgroundColor: '#FFFFFF', borderRadius: '5px' }} className='p-2 d-flex justify-content-between align-items-center'>
                            <div>
                                <p className='m-0'>{sectorDataState.sectorEnabled ? t('ENABLED') : t('NOT_ENABLED')}</p>
                            </div>

                            <div>
                                <FormGroup switch>
                                    <Input type="switch" name='sectorEnabled' checked={sectorDataState.sectorEnabled} onClick={handleChange} />
                                </FormGroup>
                            </div>
                        </div>


                        <div className='d-flex justify-content-around align-items-center mt-5 mb-4'>
                            <div className=''>
                                <p type='button' className='m-0' onClick={goCancel}>{t('CANCEL')}</p>
                            </div>

                            <div className=''>
                                <ButtonBlue onClick={handleSubmit} disabled={disabled}>
                                    {t('SAVE')}
                                </ButtonBlue>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    )
}
